import styled from "styled-components"
import theme from '../../styles/theme';
import Header from "../../components/front/Header";
import { useQuery, useQueryClient } from 'react-query';
import Tab from "../../components/Tab";
import MInoutMain from "../../components/front/inout";
import { useEffect } from 'react';
import { useState } from 'react';
import { useCallback } from 'react';


const MainWrap = styled.div`
    width: 100%;
    height: 100vh;
    background: ${theme.color.white[100]};
    opacity:${(props)=> props.status === true ? 0 : 1};
    transition: opacity 150ms ease-in-out;
    -webkit-transition: opacity 150ms ease-in-out;
`;

const MainTemplate = ({target}) => {

    const queryClient = useQueryClient();
    const {data:{status}} = useQuery('OPA',{initialData:{status:false}});

    useEffect(()=>{
        let timeOut = null;
        if(status === true){
            timeOut = setTimeout(()=>queryClient.setQueryData('OPA',{status:false}),150);
        }
        return ()=>{
            clearTimeout(timeOut);
        }
    },[status])

    return (
        <MainWrap status={status}>
            <Header />
            {target}
            {/* <Tab />
            {tabId === 0 &&
                <MInoutMain />
            } */}
        </MainWrap>
    )

}

// const MainTemplate = ({target}) => {

//     const queryClient = useQueryClient();

//     const {data: itemInfo} = useQuery('M_ITEM_INFO');

//     const [menuOpen, setMenuOpen] = useState(true);

//     return (
//         <MainWrap>
//             <Header />
//             {(itemInfo && itemInfo.length > 0) && <ItemInfo />}
//             <Menu />
//         </MainWrap>
//     )

// }

export default MainTemplate;